import { api } from "./customers";

export interface CustomerJourney {
  id: number;
  customerId: number;
  customerJourneyOption: string;
  createdAt: string;
}
export interface CustomerJourneymaster {
  id: number;
  customerJourneyName: any;
  createdAt: any;
  activeStatus: any;
  description: any;
  updatedAt: any;

  data: any;
  others: any;
}
export interface CustomerJourneyActive {
  data: CustomerJourneymaster[];
}

export interface IvfJourney {
  id: number;
  customerId: number;
  stepsId: string;
  stagesId: string;
  stepsname: string;
  stagesname: string;

  createdAt: string;
}

type CustomerJourneysResponse = CustomerJourney[];

export const CustomerJourneyApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCustomerJourneys: build.query<CustomerJourneysResponse, void>({
      query: () => "customer_journey",
      providesTags: (result) =>
        result
          ? [
              ...result["data"]?.map(({ id }) => ({
                type: "CustomerJourney" as const,
                id,
              })),
              { type: "CustomerJourney", id: "LIST" },
            ]
          : [{ type: "CustomerJourney", id: "LIST" }],
    }),
    getCustomerJourneysActive: build.query<CustomerJourneyActive, void>({
      query: () => "customer_journey_master_list",
      // providesTags: (result) =>
      //     result
      //         ? [
      //             ...result["data"]?.map(({ id }) => ({ type: 'CustomerJourney' as const, id })),
      //             { type: 'CustomerJourney', id: 'LIST' },
      //         ]
      //         : [{ type: 'CustomerJourney', id: 'LIST' }],
    }),
    addCustomerJourney: build.mutation<
      CustomerJourney,
      Partial<CustomerJourney>
    >({
      query: (body) => ({
        url: `customer_journey`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: CustomerJourney }, meta, arg) =>
        response.data,
    }),
    addIvfJourney: build.mutation<IvfJourney, Partial<IvfJourney>>({
      query: (body) => ({
        url: `customer_ivf_journey_history`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: IvfJourney }, meta, arg) =>
        response.data,
    }),
    getCustomerJourney: build.query<CustomerJourney, string>({
      query: (id) => `customer_journey/${id}`,
      transformResponse: (response: { data: CustomerJourney }, meta, arg) =>
        response.data,
    }),
    getCustomerJourneyByCustomerId: build.query<CustomerJourney[], string>({
      query: (id) => `get_customerjourneyBycustomerID/${id}`,
      transformResponse: (response: { data: CustomerJourney[] }, meta, arg) =>
        response.data,
    }),
    updateCustomerJourney: build.mutation<
      void,
      Pick<CustomerJourney, "id"> & Partial<CustomerJourney>
    >({
      query: ({ id, ...patch }) => ({
        url: `customer_journey/${id}`,
        method: "PUT",
        body: patch,
      }),
    }),
    deleteCustomerJourney: build.mutation<
      { success: boolean; id: number },
      number
    >({
      query(id) {
        return {
          url: `customer_journey/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useGetCustomerJourneysQuery,
  useGetCustomerJourneyQuery,
  useGetCustomerJourneysActiveQuery,
  useGetCustomerJourneyByCustomerIdQuery,
  useAddCustomerJourneyMutation,
  useAddIvfJourneyMutation,
  useUpdateCustomerJourneyMutation,
  useDeleteCustomerJourneyMutation,
} = CustomerJourneyApi;
